<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card border">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">{{this.label}} Data Olimpiade Tryout</h4>
                                    <div class="page-title-right">
                                        <ol class="breadcrumb m-0">
                                            <li class="breadcrumb-item"><router-link :to="{name : 'olimpiade_tryout'}">Data Olimpiade Tryout</router-link></li>
                                            <li class="breadcrumb-item active">Form</li>
                                        </ol>
                                    </div>
                                </div>

                                <form v-on:submit.prevent="onSubmit">
                                    <div class="row">
                                        <input type="hidden" name="id" v-model="form.id">
                                        <div class="form-group col-md-6 mt-3">
                                            <label>Nama / Judul Tryout</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.title" :class="{ 'is-invalid': submitted && $v.form.title.$error }">
                                            <div v-if="submitted && !$v.form.title.required" class="invalid-feedback">Judul Wajib diisi!</div>    
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Durasi (Dalam Menit)</label>
                                            <input type="number" class="form-control"
                                                placeholder="Masukan data..." v-model="form.timer" :class="{ 'is-invalid': submitted && $v.form.timer.$error }">
                                            <div v-if="submitted && !$v.form.timer.required" class="invalid-feedback">Durasi Wajib diisi!</div>
                                            <div v-if="submitted && !$v.form.timer.numeric" class="invalid-feedback">Durasi Wajib menggunakan angka!</div>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Tanggal Mulai Tryout</label>
                                            <datepicker v-model="form.start_date" :input-class="{'form-control':true}" :language="language" placeholder="Pilih Tanggal"></datepicker>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Jam Mulai Tryout</label>
                                            <input type="time" class="form-control" v-model="form.start_time" :class="{ 'is-invalid': submitted && $v.form.start_time.$error }">
                                            <div v-if="submitted && !$v.form.start_time.required" class="invalid-feedback">Jam Mulai Wajib diisi!</div>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label for="exampleFormControlSelect1">Status</label>
                                            <select class="form-select" v-model="form.status">
                                                <option value="publish">Publish</option>
                                                <option value="draft">Draft</option>
                                            </select>
                                        </div>

                                        <div class="form-group col-md-6 mt-3" v-if="form.result_lock == '1'">
                                            <label>Tanggal Hasil Tryout</label>
                                            <datepicker v-model="form.result_date" :input-class="{'form-control':true}" :language="language" placeholder="Pilih Tanggal"></datepicker>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label for="exampleFormControlSelect1">
                                                Aktifkan waktu berakhir<br/>
                                            </label>
                                            <select class="form-select" v-model="form.exam">
                                                <option value="1">Iya</option>
                                                <option value="0">Tidak</option>
                                            </select>
                                            <small>Waktu berakhir akan disamakan dengan waktu mulai tryout + durasi waktu mengerjakan</small>
                                        </div>

                                        <div class="form-group col-md-12 mt-3">
                                            <div class="alert alert-info" role="alert">
                                                <b>Keterangan : </b>
                                                <ol class="mt-2">
                                                    <li>Tryout bisa di akses member sesuai dengan <b>Tanggal dan jam mulai tryout</b>.</li>
                                                    <li><b>Hasil tryout, ranking, pembahasan & grafik nilai</b> akan muncul di halaman member sesuai dengan <b>Tanggal Hasil Tryout</b>.</li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="button-items mt-3">
                                        <button type="submit" class="btn btn-primary" :disabled="waiting">
                                        <i class="fa fa-save"></i> {{ waiting ? 'Harap tunggu ...' : 'Simpan' }}</button>
                                        <router-link :to="{name : 'olimpiade_tryout'}" class="btn btn-outline-primary">Kembali</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';   
    import {id} from 'vuejs-datepicker/dist/locale';

    import {
        required, numeric
    } from "vuelidate/lib/validators";
    
    export default {
        name: 'OlimpiadeTryout',
        metaInfo: {
            title: 'Form Olimpiade Tryout',
            titleTemplate: '%s - Gubuk Sains Prima'
        },
        components : {
            Datepicker
        },
        created() {
            this.getDataByID(this.$route.params.id);
        },
        data() {
            return {
                label           : 'Tambah',
                form : {
                    id              : "",
                    title           : "",
                    timer           : "",
                    status          : "draft",
                    result_lock     : 1,
                    start_date      : moment().format('YYYY-MM-DD'),
                    result_date     : moment().format('YYYY-MM-DD'),
                    start_time      : '',
                    exam            : 1
                },
                submitted       : false,
                waiting         : false,
                language        : id
            }
        },
        validations: {
            form: {
                title: {
                    required
                },
                start_time: {
                    required
                },
                timer: {
                    required,
                    numeric
                }
            }
        },
        methods: {
            onSubmit: function () {
                this.waiting    = true;
                this.submitted  = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Harap lengkapi form',
                    });

                    this.waiting = false;
                    return;
                } else {    
                    let formData = new FormData();

                    formData.append('id', this.form.id);
                    formData.append('title', this.form.title);
                    formData.append('timer', this.form.timer);
                    formData.append('status', this.form.status);
                    formData.append('start_date', this.convertDate(this.form.start_date));
                    formData.append('start_time', this.form.start_time);
                    formData.append('result_lock', this.form.result_lock);
                    formData.append('result_date', this.convertDate(this.form.result_date));
                    formData.append('exam', this.form.exam);

                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/olimpiade/tryout/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.$router.push({ name: 'olimpiade_tryout' });
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

                }
            },
            getDataByID: function(id) {
                if (typeof (id) !== 'undefined' && id !== null) {
                    this.label  = "Ubah";

                    let uri     = process.env.VUE_APP_APIHOST+'admin/olimpiade/tryout/detail';

                    this.dataFetch  = true;                
                    this.$http.get(uri,{
                        params : {
                            id : id
                        }
                    }).then(res => {
                        if(res.data.status) {
                            let getResponse = res.data.data;

                            this.form.id            = getResponse.id;
                            this.form.title         = getResponse.title;
                            this.form.timer         = getResponse.timer;
                            this.form.status        = getResponse.status;
                            this.form.result_lock   = getResponse.result_lock;
                            this.form.exam          = getResponse.exam;

                            if(getResponse.result_date != null) {
                                this.form.result_date    = getResponse.result_date;
                            }

                            if(getResponse.start_date != null) {
                                this.form.start_date    = getResponse.start_date;
                            }

                            if(getResponse.start_time != null) {
                                this.form.start_time    = getResponse.start_time;
                            }

                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: res.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({ name: 'olimpiade_tryout' });
                                }
                            });
                        }
                    });
                }
            },
            convertDate : function (date) {
                return moment(date, 'YYYY-MM-DD').format('yyyy-MM-DD');
            }
        }
    }
</script>